function Live() {
    <h2>Live page</h2>;
}

export default Live;
